import React from 'react';
import { Container, Row, Card, Col } from 'react-bootstrap';
import MasterPage from 'components/MasterPage';
import { useEffect } from 'react';
import { WidgetsOutlined } from '@material-ui/icons';
import * as calendar from '../../images/calendar.png';

export default function(){
  useEffect(() => {}, []);

  return (
    <>
      <Container className="mb-5">
        <Row className="col-12 mt-4 row">
          <WidgetsOutlined className="icon-title" />
          <h5 className="title-dashboard">Eventos</h5>
        </Row>
        <Row>
          <Col md="3">
            <a
              href={'https://www.scansource.com.br/webinars'}
              target="_blank"
              rel="noreferrer"
              className="card-body mt-2 text-primary font-weight-bold d-block shadow bg-white rounded text-center pt-5"
              style={{ height: '12rem', marginBottom: '10px' }}
            >
              <img
                className="d-inline-block mb-3 icon-program"
                src={calendar}
                alt=""
                width="50"
              />
              <p>Calendário de Eventos</p>
            </a>
          </Col>
          {/* <Col className="col-12 d-flex justify-content-center my-5">
            <Card.Body className="shadow bg-white rounded text-center m-2 col-6 pt-5">
              <Row className="text-center row">
                <Col xs="12" className="mb-5 mt-5">
                <img className="d-inline-block mb-3 icon-program" src={soon} alt="" width="50" />
                  <h5 className="title-dashboard">Em breve!</h5>
                </Col>
              </Row>
            </Card.Body>
          </Col> */}
        </Row>
      </Container>
    </>
  );
};
